import { Component } from '@angular/core';
import * as $ from "jquery";
import { GuiService } from './shared/gui.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  title = 'asc';

  constructor(public guiService: GuiService) {

  }
}
